module.exports = __webpack_public_path__ + "img/dollar-circle.0ee39b31.svg";